/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorMarkup as ResolvedLabradorMarkup } from 'base/components/labrador/Markup';

export const LabradorMarkup: typeof ResolvedLabradorMarkup = withLabradorInstanceof((props) => {
    return <ResolvedLabradorMarkup {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorMarkupProps = PropsFromComponent<typeof LabradorMarkup>;
